/*
openai - configured with api key
prompt - what task need to perform
content - passing user content as a input
model - openai model to use

perform openai api request and return the modified content based on what we prompted.
*/
async function reWriteContent(openai,prompt,content,model) {
    //console.log(content,desc,model);

    //console.log('rewrite with ai')

    try {
        const response = await openai.chat.completions.create({
            model: model,
            messages: [
              {
                "role": "system",
                "content": prompt
              },
              {
                "role": "user",
                "content": content
              }
            ],
            temperature: 0.7,
            //max_tokens: 64,
            top_p: 1,
        });   

        // console.log(response);

        if(response.choices && response.choices[0].message && response.choices[0].message.content) {
            return response.choices[0].message.content;
        }

        // var content_desc = "notification open ai sample response"

        // return content_desc;

    } catch (error) {
        console.log(error)
    }

}

function isAiEnabled(menu) {
    //console.log(global.$config["aiassistant"]);
    var enable = false;

    if(global.$config["aiassistant"] && global.$config["aiassistant"][menu]) {
        enable = global.$config["aiassistant"][menu].enable ? global.$config["aiassistant"][menu].enable : false
    }

    return enable;
}

function getPrompts(menu) {
    var prompts = []

    if(global.$config["aiassistant"] && global.$config["aiassistant"][menu] && global.$config["aiassistant"][menu].prompt) {
        prompts = global.$config["aiassistant"][menu].prompt
    }

    return prompts;
}

function isCustomPrompt(menu) {
    var enabled = false;

    if(global.$config["aiassistant"] && global.$config["aiassistant"][menu] && global.$config["aiassistant"][menu].customprompt) {
        enabled = global.$config["aiassistant"][menu].customprompt ? global.$config["aiassistant"][menu].customprompt : false
    }

    return enabled;
}

function getAiCredentials() {
    var key = '', model = ''

    if(global.$config["aiassistant"] && global.$config["aiassistant"].openai.apikey && global.$config["aiassistant"].openai.model) {
        key = global.$config["aiassistant"].openai.apikey
        model = global.$config["aiassistant"].openai.model
    }

    return [key, model];
}

function isOpenAi() {
    if(global.$config["aiassistant"].type == "openai") {
        return true
    }

    return false;
}

module.exports = { reWriteContent, isAiEnabled, isCustomPrompt, getPrompts, getAiCredentials, isOpenAi }